import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

const FooterCTA = () => {
  return (
    <section className="w-full bg-[#FFA500]">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] py-6 md:py-10 lg:py-12 
        flex flex-col lg:flex-row items-center justify-between text-black">
        <p className="w-full md:w-[80%] lg:w-[70%] text-[24px] md:text-[30px] lg:text-[42px] font-bold text-left leading-tight">
          Apply Now for <span className="font-bold">2026 Admissions & Graduate</span>  With a Degree and Real-World Experience
        </p>
        <Link
          id="btn-apply-now-bottom"
          href="https://application.msu.edu.in/campus-programme-registration"
          className="w-full lg:w-auto mt-4 lg:mt-0 flex justify-center items-center gap-2 bg-[#081E2D] text-white px-8 py-3 hover:scale-105 transition-transform"
        >
          Apply Now
          <ArrowRight size={20} />
        </Link>
      </div>
    </section>
  );
};

export default FooterCTA;
